<script setup>
import { COOKIE_SETTINGS_HASH, cookieBannerMounted } from '../../helpers/cookieSettings';
</script>

<template>
    <li v-if="cookieBannerMounted">
        <a :href="COOKIE_SETTINGS_HASH">
            <mf-translate domainkey="cookieBanner:cookieSettings"></mf-translate>
        </a>
    </li>
</template>
